import {Amplify} from "aws-amplify";
import {v4 as uuidv4} from "uuid";

export interface AmplifyConfigOptions {
  endpoint: string;
  region: string;
  getAccessToken: () => string | undefined;
  getIdToken: () => string | undefined;
}

export function configureAmplify({
  endpoint,
  region,
  getAccessToken,
  getIdToken
}: AmplifyConfigOptions): void {
  Amplify.configure(
    {
      API: {
        GraphQL: {
          endpoint,
          region,
          defaultAuthMode: "none"
        }
      }
    },
    {
      API: {
        GraphQL: {
          headers: async () => {
            const accessToken = getAccessToken();
            const idToken = getIdToken();
            const headers: Record<string, string> = {
              "X-CoxAuto-Correlation-Id": uuidv4()
            };
            if (accessToken) {
              headers["Authorization"] = `Bearer ${accessToken}`;
            }
            if (idToken) {
              headers["X-Bridge-Id"] = `Bearer ${idToken}`;
            }
            return headers;
          }
        }
      }
    }
  );
}
